import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

export const TopBarWrapper = styled.div`
  position: relative;
  display: flex;
  height: var(--size-top-bar);
  flex-shrink: 0;

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background-color: var(--color-line);
    content: ' ';
  }
`

export const TopBarTime = styled.div`
  ${Cover()}
  position: relative;
  color: ${({ theme }) => theme.colors.global};
  text-transform: uppercase;
  font-size: 1.5rem;
  font-weight: 500;
  margin-right: auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
`

export const TopBarLogin = styled.button`
  ${Reset('button')}
  height: var(--size-top-bar);
  width: var(--size-top-bar);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: var(--color-global);
  }
`

export const TopBarAssistLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  ${TransitionPrimary('opacity, transform, visibility')}

  &:nth-child(2) {
    ${Cover()}
    opacity: 0;
    transform: translateY(-0.5rem);
    visibility: hidden;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.75rem;
  }
`

export const TopBarAssist = styled.button`
  ${Reset('button')}
  position: relative;
  padding: 0 1.5rem;
  background-color: var(--color-global);
  color: var(--color-inverted);
  ${TransitionPrimary('background-color')}

  svg {
    fill: currentColor;
  }
  ${props =>
    props.$active &&
    css`
      background-color: var(--color-green);
      ${TopBarAssistLabel} {
        &:nth-child(1) {
          opacity: 0;
          transform: translateY(0.5rem);
          visibility: hidden;
        }

        &:nth-child(2) {
          opacity: 1;
          transform: translateY(0);
          visibility: visible;
        }
      }
    `};
`

export const TopBarUtils = styled.div`
  margin-left: auto;
  display: flex;
`
